module.exports = __webpack_public_path__ + "static/media/remote-trails-logo.5c6113e6.png";